import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import FoldersCreate from "components/Folders/FoldersCreate";
import * as folderReducer from "containers/Folders/reducer";
import * as adminReducer from "containers/Admin/reducer";
import * as loginReducer from "containers/Login/reducer";

class FoldersCreateContainer extends React.Component {
  render() {
    return <FoldersCreate {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    createFolder: (name, description, collaborators, defaultRoleType) =>
      dispatch(
        folderReducer.createFolder({
          name,
          description,
          collaborators,
          defaultRoleType
        })
      ),
    editFolder: (name, description, collaborators) =>
      dispatch(
        folderReducer.patchFolder({
          id: ownProps.id,
          name,
          description
        })
      ),
    deleteFolder: () => dispatch(folderReducer.deleteFolder(ownProps.id)),
    setDefaultFolder: () => ownProps.id && dispatch(folderReducer.setDefaultFolder(ownProps.id)),
    addUserRole: (userId, role) => dispatch(folderReducer.addUserRole(ownProps.id, userId, role)),
    deleteUserRole: (roleId) => dispatch(folderReducer.deleteUserRole(ownProps.id, roleId)),
    patchUserRole: (roleId, role) => dispatch(folderReducer.patchUserRole(ownProps.id, roleId, role))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    selectedFolder: folderReducer.getSelectedFolderData(state),
    defaultFolderId: folderReducer.getDefaultFolderId(state),
    users: adminReducer.getActiveUsers(state),
    userName: loginReducer.getUserName(state),
    userId: loginReducer.getUserID(state),
    roles: folderReducer.getRoleOptions(state),
    folderRoles: ownProps.id ? folderReducer.getRoles(state, ownProps.id) : undefined,
    folderName: ownProps.id ? folderReducer.getName(state, ownProps.id) : undefined,
    folderDescription: ownProps.id ? folderReducer.getDescription(state, ownProps.id) : undefined,
    userRole: ownProps.id ? folderReducer.getUserRoleType(state, ownProps.id) : undefined,
    canDelete: ownProps.id ? folderReducer.getUserDeletePermission(state, ownProps.id) : undefined,
    canEdit: ownProps.id ? folderReducer.getUserEditPermission(state, ownProps.id) : undefined,
    canManagePermissions: ownProps.id ? folderReducer.getUserManagePermissions(state, ownProps.id) : undefined
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(FoldersCreateContainer);
